@if (!listContent) {
  @if (mapObject && mapObject.size>0) {
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col" class="name"><h3>{{'name' | translate}}</h3></th>
          <th scope="col" class="value"><h3>{{'value' | translate}}</h3></th>
        </tr>
      </thead>
      <tbody>
        @for (obj of mapObject | keyvalue; track obj) {
          <tr>
            <th scope="row"><h4>{{formatProbeDetectName(obj.key)}}</h4></th>
            <td>
              @if (formatValue(obj.value)!='list') {
                <h4 class="value">{{obj.value}}</h4>
              } @else {
                <div class="d-flex justify-content-end">
                  <button class="btn btn-outline-primary" (click)="listContent=true; getListe(obj.value); actif(obj.key)">{{'see-the-list' | translate}}</button>
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <div id="error">
      <app-loading-error [boolean]="false" [search]="'attestations-modal-lprobedetectors-error-message' | translate"></app-loading-error>
    </div>
  }
} @else {
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col" class="name"><h3>{{'value' | translate}}</h3></th>
      </tr>
    </thead>
    <tbody>
      @for (val of listObject; track val) {
        <tr>
          @if (val) {
            <th scope="row"><h4>{{val}}</h4></th>
          }
        </tr>
      }
    </tbody>
  </table>
}

